export default [
  {
    name: "A: Weapon ability: POISON",
    computed_keywords: [],
    computed_leaders: [],
    computed_roles: ["Attacker: Ranged"],
    computed_toughness: null,
    order_slain_auto: true,
    order_slain_model_types: [
      {
        modelTypeId: "f78abe52-f824-4c63-afc0-f4bf90037967",
        modelTypeName: null,
        unitId: "34de744e-b52e-4a80-9a05-4bc70efc3396",
      },
    ],
    units: [
      {
        id: "34de744e-b52e-4a80-9a05-4bc70efc3396",
        leader: false,
        name: "A: Weapon ability: POISON > Unit 1",
        abilities: [],
        points: null,
        model_types: [
          {
            weapons: [
              {
                name: "Baseline",
                type: "Ranged",
                attacks: 1,
                strength: 2,
                ap: 0,
                damage: 1,
                countPerUnit: 10,
                id: "61d2474d-8ff8-493b-977c-dfd864abc310",
                bs: 3,
                ws: null,
                nameUnique: "Baseline",
                abilities: [],
              },
              {
                name: "Legacy POISON weapon with strength '*'",
                type: "Ranged",
                attacks: 1,
                strength: "*",
                ap: 0,
                damage: 1,
                abilities: [
                  {
                    description:
                      "Always wound on a 4+ (unmodified) (excludes VEHICLE, TITANIC)",
                    id: "ee9569bf-a11c-483d-9fdb-16153c811781",
                    conditions: [
                      {
                        data: {
                          attackStep: {
                            title: "Wound roll",
                            key: "woundRoll",
                          },
                          rollReq: {
                            title: "Specific roll",
                            key: "specificRoll",
                          },
                          rollState: {
                            title: "Unmodified",
                            key: "unmodified",
                          },
                          rollTarget: {
                            title: "Or greater",
                            key: "orGreater",
                          },
                          rollValue: "4",
                        },
                        preselected: false,
                        text: "Attack step roll",
                        type: "attackStepRoll",
                      },
                      {
                        data: {
                          keywords: ["VEHICLE", "TITANIC"],
                        },
                        preselected: false,
                        text: "Keywords (excludes)",
                        type: "keywordsExcludes",
                      },
                    ],
                    scope: ["weapon"],
                    effect: {
                      data: {
                        irrespective: false,
                        outcome: {
                          title: "Wound",
                          key: "wound",
                        },
                        type: {
                          title: "Always",
                          key: "always",
                        },
                        crit: false,
                      },
                      text: "Override requirements",
                      type: "overrideReqs",
                    },
                    aliases: [],
                    aliasActive: true,
                    sharedWithAllUnits: false,
                  },
                ],
                countPerUnit: 10,
                id: "c3055cfb-7a7d-414c-84df-cc9a795ea142",
                bs: 3,
                ws: null,
                nameUnique: "Legacy POISON weapon with strength '*'",
              },
              {
                name: "Baseline with POISON:4",
                type: "Ranged",
                attacks: 1,
                strength: 2,
                ap: 0,
                damage: 1,
                abilities: [
                  {
                    description:
                      "Always wound on a 4+ (unmodified) (excludes VEHICLE, TITANIC)",
                    id: "c054f7b3-07c5-49e8-8e6b-63091e703290",
                    conditions: [
                      {
                        data: {
                          attackStep: {
                            title: "Wound roll",
                            key: "woundRoll",
                          },
                          rollReq: {
                            title: "Specific roll",
                            key: "specificRoll",
                          },
                          rollState: {
                            title: "Unmodified",
                            key: "unmodified",
                          },
                          rollTarget: {
                            title: "Or greater",
                            key: "orGreater",
                          },
                          rollValue: "4",
                        },
                        preselected: false,
                        text: "Attack step roll",
                        type: "attackStepRoll",
                      },
                      {
                        data: {
                          keywords: ["VEHICLE", "TITANIC"],
                        },
                        preselected: false,
                        text: "Keywords (excludes)",
                        type: "keywordsExcludes",
                      },
                    ],
                    scope: ["weapon"],
                    effect: {
                      data: {
                        irrespective: false,
                        outcome: {
                          title: "Wound",
                          key: "wound",
                        },
                        type: {
                          title: "Always",
                          key: "always",
                        },
                        crit: false,
                      },
                      text: "Override requirements",
                      type: "overrideReqs",
                    },
                    aliases: [],
                    aliasActive: true,
                    sharedWithAllUnits: false,
                  },
                ],
                countPerUnit: 10,
                id: "c1d03d10-56fa-4426-b253-a597df6fb003",
                bs: 3,
                ws: null,
                nameUnique: "Baseline with POISON:4",
              },
              {
                name: "Baseline with POISON:3",
                type: "Ranged",
                attacks: 1,
                strength: 2,
                ap: 0,
                damage: 1,
                abilities: [
                  {
                    description:
                      "Always wound on a 3+ (unmodified) (excludes VEHICLE, TITANIC)",
                    id: "a0fb3665-8317-4962-a729-24defa9622b3",
                    conditions: [
                      {
                        data: {
                          attackStep: {
                            title: "Wound roll",
                            key: "woundRoll",
                          },
                          rollReq: {
                            title: "Specific roll",
                            key: "specificRoll",
                          },
                          rollState: {
                            title: "Unmodified",
                            key: "unmodified",
                          },
                          rollTarget: {
                            title: "Or greater",
                            key: "orGreater",
                          },
                          rollValue: "3",
                        },
                        preselected: false,
                        text: "Attack step roll",
                        type: "attackStepRoll",
                      },
                      {
                        data: {
                          keywords: ["VEHICLE", "TITANIC"],
                        },
                        preselected: false,
                        text: "Keywords (excludes)",
                        type: "keywordsExcludes",
                      },
                    ],
                    scope: ["weapon"],
                    effect: {
                      data: {
                        irrespective: false,
                        outcome: {
                          title: "Wound",
                          key: "wound",
                        },
                        type: {
                          title: "Always",
                          key: "always",
                        },
                        crit: false,
                      },
                      text: "Override requirements",
                      type: "overrideReqs",
                    },
                    aliases: [],
                    aliasActive: true,
                    sharedWithAllUnits: false,
                  },
                ],
                countPerUnit: 10,
                id: "85d592a0-0bf6-4cc4-b673-57fd293b326a",
                bs: 3,
                ws: null,
                nameUnique: "Baseline with POISON:3",
              },
              {
                name: "Baseline with POISON:2",
                type: "Ranged",
                attacks: 1,
                strength: 2,
                ap: 0,
                damage: 1,
                abilities: [
                  {
                    description:
                      "Always wound on a 2+ (unmodified) (excludes VEHICLE, TITANIC)",
                    id: "264a2300-b6fc-462d-8924-5975e08af829",
                    conditions: [
                      {
                        data: {
                          attackStep: {
                            title: "Wound roll",
                            key: "woundRoll",
                          },
                          rollReq: {
                            title: "Specific roll",
                            key: "specificRoll",
                          },
                          rollState: {
                            title: "Unmodified",
                            key: "unmodified",
                          },
                          rollTarget: {
                            title: "Or greater",
                            key: "orGreater",
                          },
                          rollValue: "2",
                        },
                        preselected: false,
                        text: "Attack step roll",
                        type: "attackStepRoll",
                      },
                      {
                        data: {
                          keywords: ["VEHICLE", "TITANIC"],
                        },
                        preselected: false,
                        text: "Keywords (excludes)",
                        type: "keywordsExcludes",
                      },
                    ],
                    scope: ["weapon"],
                    effect: {
                      data: {
                        irrespective: false,
                        outcome: {
                          title: "Wound",
                          key: "wound",
                        },
                        type: {
                          title: "Always",
                          key: "always",
                        },
                        crit: false,
                      },
                      text: "Override requirements",
                      type: "overrideReqs",
                    },
                    aliases: [],
                    aliasActive: true,
                    sharedWithAllUnits: false,
                  },
                ],
                countPerUnit: 10,
                id: "2cc33f7a-6b6c-4d88-aa63-d8beaea7f89c",
                bs: 3,
                ws: null,
                nameUnique: "Baseline with POISON:2",
              },
            ],
            id: "f78abe52-f824-4c63-afc0-f4bf90037967",
            name: "A: Weapon ability: POISON > Unit 1 > Model type 1",
            ignore: null,
            invuln: null,
          },
        ],
        abilities_selected: [],
      },
    ],
    weapons_selected_melee: [],
    weapons_selected_ranged: [
      "61d2474d-8ff8-493b-977c-dfd864abc310",
      "c3055cfb-7a7d-414c-84df-cc9a795ea142",
      "c1d03d10-56fa-4426-b253-a597df6fb003",
      "85d592a0-0bf6-4cc4-b673-57fd293b326a",
      "2cc33f7a-6b6c-4d88-aa63-d8beaea7f89c",
    ],
  },
  {
    name: "A: Weapon ability: PLAGUE WEAPON",
    computed_keywords: [],
    computed_leaders: [],
    computed_roles: ["Attacker: Ranged"],
    computed_toughness: null,
    order_slain_auto: true,
    order_slain_model_types: [
      {
        modelTypeId: "af04ff11-7dc6-4e8f-913c-c0751e803fd9",
        modelTypeName: null,
        unitId: "aa2a3744-f087-4af2-8263-f6103498e05a",
      },
    ],
    units: [
      {
        id: "aa2a3744-f087-4af2-8263-f6103498e05a",
        leader: false,
        name: "A: Weapon ability: PLAGUE WEAPON > Unit 1",
        abilities: [],
        points: null,
        model_types: [
          {
            weapons: [
              {
                name: "Baseline",
                type: "Ranged",
                attacks: 10,
                strength: 6,
                ap: -2,
                damage: 1,
                countPerUnit: 4,
                id: "ee2f4b5b-3449-48d3-a3e3-e68556ceed1a",
                bs: 3,
                ws: null,
                nameUnique: "Baseline",
                abilities: [],
              },
              {
                name: "Baseline with PLAGUE WEAPON",
                type: "Ranged",
                attacks: 10,
                strength: 6,
                ap: -2,
                damage: 1,
                abilities: [
                  {
                    description: "Re-roll all wound roll results of 1",
                    id: "86fcb375-8f5b-4d3d-9e04-ab1d142e387c",
                    scope: ["weapon"],
                    effect: {
                      data: {
                        application: {
                          title: "Wound roll",
                          key: "woundRoll",
                        },
                        limit: {
                          title: "None",
                          key: "none",
                        },
                        resultToReRoll: {
                          title: "Single",
                          key: "single",
                        },
                        valueRange: [],
                        valueSingle: 1,
                      },
                      text: "Re-roll",
                      type: "reRoll",
                    },
                    conditions: [],
                    aliases: [],
                    aliasActive: true,
                    sharedWithAllUnits: false,
                  },
                ],
                countPerUnit: 4,
                id: "f9f591cb-a43c-47f8-9530-8a6fccbd6570",
                bs: 3,
                ws: null,
                nameUnique: "Baseline with PLAGUE WEAPON",
              },
            ],
            id: "af04ff11-7dc6-4e8f-913c-c0751e803fd9",
            name: "A: Weapon ability: PLAGUE WEAPON > Unit 1 > Model type 1",
            ignore: null,
            invuln: null,
          },
        ],
        abilities_selected: [],
      },
    ],
    weapons_selected_melee: [],
    weapons_selected_ranged: [
      "ee2f4b5b-3449-48d3-a3e3-e68556ceed1a",
      "f9f591cb-a43c-47f8-9530-8a6fccbd6570",
    ],
  },
  {
    name: "A: Weapon ability: WOUND:6+=AP:-3",
    computed_keywords: [],
    computed_leaders: [],
    computed_roles: ["Attacker: Ranged"],
    computed_toughness: null,
    order_slain_auto: true,
    order_slain_model_types: [
      {
        modelTypeId: "97e675a5-d482-4c14-9f55-64b251cb8391",
        modelTypeName: null,
        unitId: "f8ef051d-a3e3-4a70-a4e8-c2b06b46822d",
      },
    ],
    units: [
      {
        id: "f8ef051d-a3e3-4a70-a4e8-c2b06b46822d",
        leader: false,
        name: "A: Weapon ability: WOUND:6+=AP:-3 > Unit 1",
        abilities: [],
        points: null,
        model_types: [
          {
            weapons: [
              {
                name: "Baseline",
                type: "Ranged",
                attacks: 2,
                strength: 4,
                ap: 0,
                damage: 1,
                countPerUnit: 20,
                id: "1b3c78be-ce6e-451f-a27e-43ff74997188",
                bs: 3,
                ws: null,
                nameUnique: "Baseline",
                abilities: [],
              },
              {
                name: "Baseline with weapon ability",
                type: "Ranged",
                attacks: 2,
                strength: 4,
                ap: 0,
                damage: 1,
                abilities: [
                  {
                    description: "Wound roll of 6+ : set AP to -3",
                    id: "8353ea93-b7bc-4eab-93e3-de7031d3f350",
                    conditions: [
                      {
                        data: {
                          attackStep: {
                            title: "Wound roll",
                            key: "woundRoll",
                          },
                          rollReq: {
                            title: "Specific roll",
                            key: "specificRoll",
                          },
                          rollState: {
                            title: "Modified",
                            key: "modified",
                          },
                          rollTarget: {
                            title: "Or greater",
                            key: "orGreater",
                          },
                          rollValue: "6",
                        },
                        preselected: false,
                        text: "Attack step roll",
                        type: "attackStepRoll",
                        required: true,
                      },
                    ],
                    effect: {
                      data: {
                        application: {
                          title: "AP",
                          key: "ap",
                        },
                        operator: {
                          title: "Replace",
                          key: "replace",
                        },
                        absoluteValue: -3,
                      },
                      text: "Modify (absolute)",
                      type: "modifyAbsolute",
                    },
                    scope: ["weapon"],
                    aliases: [],
                    aliasActive: true,
                    sharedWithAllUnits: false,
                  },
                ],
                countPerUnit: 20,
                id: "e5afef3b-9c8a-426b-95f1-4bd2b2a2b91b",
                bs: 3,
                ws: null,
                nameUnique: "Baseline with weapon ability",
              },
            ],
            id: "97e675a5-d482-4c14-9f55-64b251cb8391",
            name: "A: Weapon ability: WOUND:6+=AP:-3 > Unit 1 > Model type 1",
            ignore: null,
            invuln: null,
          },
        ],
        abilities_selected: [],
      },
    ],
    weapons_selected_melee: [],
    weapons_selected_ranged: [
      "1b3c78be-ce6e-451f-a27e-43ff74997188",
      "e5afef3b-9c8a-426b-95f1-4bd2b2a2b91b",
    ],
  },
  {
    name: "A: Weapon ability: WOUND:6+=AP:-4",
    computed_keywords: [],
    computed_leaders: [],
    computed_roles: ["Attacker: Ranged"],
    computed_toughness: null,
    order_slain_auto: true,
    order_slain_model_types: [
      {
        modelTypeId: "a6decf6f-b293-41cf-a551-7143d9b6bea0",
        modelTypeName: null,
        unitId: "0c2c76e7-46b9-44d2-b3dc-d1a90b1509cd",
      },
    ],
    units: [
      {
        id: "0c2c76e7-46b9-44d2-b3dc-d1a90b1509cd",
        leader: false,
        name: "A: Weapon ability: WOUND:6+=AP:-4 > Unit 1",
        abilities: [],
        points: null,
        model_types: [
          {
            weapons: [
              {
                name: "Baseline",
                type: "Ranged",
                attacks: 2,
                strength: 4,
                ap: 0,
                damage: 1,
                countPerUnit: 20,
                id: "ce8b2f13-a500-4ef2-abee-3645428de520",
                bs: 3,
                ws: null,
                nameUnique: "Baseline",
                abilities: [],
              },
              {
                name: "Baseline with weapon ability",
                type: "Ranged",
                attacks: 2,
                strength: 4,
                ap: 0,
                damage: 1,
                abilities: [
                  {
                    description: "Wound roll of 6+ : set AP to -4",
                    id: "550a06de-3865-4b18-a96f-d85066c2d94e",
                    conditions: [
                      {
                        data: {
                          attackStep: {
                            title: "Wound roll",
                            key: "woundRoll",
                          },
                          rollReq: {
                            title: "Specific roll",
                            key: "specificRoll",
                          },
                          rollState: {
                            title: "Modified",
                            key: "modified",
                          },
                          rollTarget: {
                            title: "Or greater",
                            key: "orGreater",
                          },
                          rollValue: "6",
                        },
                        preselected: false,
                        text: "Attack step roll",
                        type: "attackStepRoll",
                        required: true,
                      },
                    ],
                    effect: {
                      data: {
                        application: {
                          title: "AP",
                          key: "ap",
                        },
                        operator: {
                          title: "Replace",
                          key: "replace",
                        },
                        absoluteValue: -4,
                      },
                      text: "Modify (absolute)",
                      type: "modifyAbsolute",
                    },
                    scope: ["weapon"],
                    aliases: [],
                    aliasActive: true,
                    sharedWithAllUnits: false,
                  },
                ],
                countPerUnit: 20,
                id: "293bae4a-9ce4-48bb-8ed5-cfbce7bc07d9",
                bs: 3,
                ws: null,
                nameUnique: "Baseline with weapon ability",
              },
            ],
            id: "a6decf6f-b293-41cf-a551-7143d9b6bea0",
            name: "A: Weapon ability: WOUND:6+=AP:-4 > Unit 1 > Model type 1",
            ignore: null,
            invuln: null,
          },
        ],
        abilities_selected: [],
      },
    ],
    weapons_selected_melee: [],
    weapons_selected_ranged: [
      "ce8b2f13-a500-4ef2-abee-3645428de520",
      "293bae4a-9ce4-48bb-8ed5-cfbce7bc07d9",
    ],
  },
  {
    name: "A: Weapon ability: WOUND:6+=AP:-6",
    computed_keywords: [],
    computed_leaders: [],
    computed_roles: ["Attacker: Ranged"],
    computed_toughness: null,
    order_slain_auto: true,
    order_slain_model_types: [
      {
        modelTypeId: "372aab99-4eba-4428-9856-306049338683",
        modelTypeName: null,
        unitId: "0e2469a9-36ef-488f-952f-49ff4511c0ee",
      },
    ],
    units: [
      {
        id: "0e2469a9-36ef-488f-952f-49ff4511c0ee",
        leader: false,
        name: "A: Weapon ability: WOUND:6+=AP:-6 > Unit 1",
        abilities: [],
        points: null,
        model_types: [
          {
            weapons: [
              {
                name: "Baseline",
                type: "Ranged",
                attacks: 2,
                strength: 4,
                ap: 0,
                damage: 1,
                countPerUnit: 20,
                id: "809b7cff-7b9b-4fe6-ba2e-98c346432f58",
                bs: 3,
                ws: null,
                nameUnique: "Baseline",
                abilities: [],
              },
              {
                name: "Baseline with weapon ability",
                type: "Ranged",
                attacks: 2,
                strength: 4,
                ap: 0,
                damage: 1,
                abilities: [
                  {
                    description: "Wound roll of 6+ : set AP to -6",
                    id: "648ed621-31c5-4640-b3a1-a2eca082bd34",
                    conditions: [
                      {
                        data: {
                          attackStep: {
                            title: "Wound roll",
                            key: "woundRoll",
                          },
                          rollReq: {
                            title: "Specific roll",
                            key: "specificRoll",
                          },
                          rollState: {
                            title: "Modified",
                            key: "modified",
                          },
                          rollTarget: {
                            title: "Or greater",
                            key: "orGreater",
                          },
                          rollValue: "6",
                        },
                        preselected: false,
                        text: "Attack step roll",
                        type: "attackStepRoll",
                        required: true,
                      },
                    ],
                    effect: {
                      data: {
                        application: {
                          title: "AP",
                          key: "ap",
                        },
                        operator: {
                          title: "Replace",
                          key: "replace",
                        },
                        absoluteValue: -6,
                      },
                      text: "Modify (absolute)",
                      type: "modifyAbsolute",
                    },
                    scope: ["weapon"],
                    aliases: [],
                    aliasActive: true,
                    sharedWithAllUnits: false,
                  },
                ],
                countPerUnit: 20,
                id: "f4957841-f92b-4612-8b79-358b63076815",
                bs: 3,
                ws: null,
                nameUnique: "Baseline with weapon ability",
              },
            ],
            id: "372aab99-4eba-4428-9856-306049338683",
            name: "A: Weapon ability: WOUND:6+=AP:-6 > Unit 1 > Model type 1",
            ignore: null,
            invuln: null,
          },
        ],
        abilities_selected: [],
      },
    ],
    weapons_selected_melee: [],
    weapons_selected_ranged: [
      "809b7cff-7b9b-4fe6-ba2e-98c346432f58",
      "f4957841-f92b-4612-8b79-358b63076815",
    ],
  },
  {
    name: "A: Weapon ability: WOUND:6+=+1MW",
    computed_keywords: [],
    computed_leaders: [],
    computed_roles: ["Attacker: Ranged"],
    computed_toughness: null,
    order_slain_auto: true,
    order_slain_model_types: [
      {
        modelTypeId: "07c49d32-42d8-4df1-98dc-9a5293296321",
        modelTypeName: null,
        unitId: "a03ddbdd-66ab-4f78-aebd-7927293922fa",
      },
    ],
    units: [
      {
        id: "a03ddbdd-66ab-4f78-aebd-7927293922fa",
        leader: false,
        name: "A: Weapon ability: WOUND:6+=+1MW > Unit 1",
        abilities: [],
        points: null,
        model_types: [
          {
            weapons: [
              {
                name: "Baseline",
                type: "Ranged",
                attacks: 2,
                strength: 4,
                ap: 0,
                damage: 1,
                countPerUnit: 10,
                id: "99f5070c-0b1f-49dc-8f3d-24741fbc1b7f",
                bs: 3,
                ws: null,
                nameUnique: "Baseline",
                abilities: [],
              },
              {
                name: "Baseline with WOUND:6+=+1MW",
                type: "Ranged",
                attacks: 2,
                strength: 4,
                ap: 0,
                damage: 1,
                abilities: [
                  {
                    description: "Wound roll of 6+ : 1 mortal wound",
                    id: "142cc9cf-7c2c-47a4-acd3-e0bb671e0f4a",
                    conditions: [
                      {
                        data: {
                          attackStep: {
                            title: "Wound roll",
                            key: "woundRoll",
                          },
                          rollReq: {
                            title: "Specific roll",
                            key: "specificRoll",
                          },
                          rollState: {
                            title: "Modified",
                            key: "modified",
                          },
                          rollTarget: {
                            title: "Or greater",
                            key: "orGreater",
                          },
                          rollValue: "6",
                        },
                        preselected: false,
                        text: "Attack step roll",
                        type: "attackStepRoll",
                        required: true,
                      },
                    ],
                    effect: {
                      data: {
                        attackSequenceEnds: false,
                        cap: null,
                        mortalWoundsValue: 1,
                        matchWeaponDamage: false,
                      },
                      text: "Mortal wounds",
                      type: "mortalWounds",
                    },
                    scope: ["weapon"],
                    aliases: [],
                    aliasActive: true,
                    sharedWithAllUnits: false,
                  },
                ],
                countPerUnit: 10,
                id: "e333a449-14ae-4432-982f-efd6f2c8cbfb",
                bs: 3,
                ws: null,
                nameUnique: "Baseline with WOUND:6+=+1MW",
              },
            ],
            id: "07c49d32-42d8-4df1-98dc-9a5293296321",
            name: "A: Weapon ability: WOUND:6+=+1MW > Unit 1 > Model type 1",
            ignore: null,
            invuln: null,
          },
        ],
        abilities_selected: [],
      },
    ],
    weapons_selected_melee: [],
    weapons_selected_ranged: [
      "99f5070c-0b1f-49dc-8f3d-24741fbc1b7f",
      "e333a449-14ae-4432-982f-efd6f2c8cbfb",
    ],
  },
  {
    name: "A: Weapon ability: HIT:6=+2HITS",
    computed_keywords: [],
    computed_leaders: [],
    computed_roles: ["Attacker: Ranged"],
    computed_toughness: null,
    order_slain_auto: true,
    order_slain_model_types: [
      {
        modelTypeId: "e86acf58-401b-4bba-9f0b-65852d11e51c",
        modelTypeName: null,
        unitId: "6d9b5bfb-26da-44b0-9834-3dced23d0508",
      },
    ],
    units: [
      {
        id: "6d9b5bfb-26da-44b0-9834-3dced23d0508",
        leader: false,
        name: "A: Weapon ability: HIT:6=+2HITS > Unit 1",
        abilities: [],
        points: null,
        model_types: [
          {
            weapons: [
              {
                name: "Baseline",
                type: "Ranged",
                attacks: 3,
                strength: 5,
                ap: 0,
                damage: 1,
                countPerUnit: 5,
                id: "f8be8a98-7414-46a9-9786-e7eabc20a79c",
                bs: 3,
                ws: null,
                nameUnique: "Baseline",
                abilities: [],
              },
              {
                name: "Baseline with weapon ability",
                type: "Ranged",
                attacks: 3,
                strength: 5,
                ap: 0,
                damage: 1,
                abilities: [
                  {
                    description: "Hit roll of 6 (unmodified) : 2 extra hits",
                    id: "857a06a2-d3b6-4612-81fa-d7df1710b86a",
                    conditions: [
                      {
                        data: {
                          attackStep: {
                            title: "Hit roll",
                            key: "hitRoll",
                          },
                          rollReq: {
                            title: "Specific roll",
                            key: "specificRoll",
                          },
                          rollState: {
                            title: "Unmodified",
                            key: "unmodified",
                          },
                          rollTarget: {
                            title: "Exact",
                            key: "exact",
                          },
                          rollValue: "6",
                        },
                        preselected: false,
                        text: "Attack step roll",
                        type: "attackStepRoll",
                        required: true,
                      },
                    ],
                    effect: {
                      data: {
                        option: {
                          title: "Extra hits",
                          key: "extraHits",
                        },
                        extrasValue: "2",
                      },
                      text: "Generate extras",
                      type: "generateExtras",
                    },
                    scope: ["weapon"],
                    aliases: [],
                    aliasActive: true,
                    sharedWithAllUnits: false,
                  },
                ],
                countPerUnit: 5,
                id: "e0c67c35-c40a-4fa8-ae99-53cfaa89c9a6",
                bs: 3,
                ws: null,
                nameUnique: "Baseline with weapon ability",
              },
            ],
            id: "e86acf58-401b-4bba-9f0b-65852d11e51c",
            name: "A: Weapon ability: HIT:6=+2HITS > Unit 1 > Model type 1",
            ignore: null,
            invuln: null,
          },
        ],
        abilities_selected: [],
      },
    ],
    weapons_selected_melee: [],
    weapons_selected_ranged: [
      "f8be8a98-7414-46a9-9786-e7eabc20a79c",
      "e0c67c35-c40a-4fa8-ae99-53cfaa89c9a6",
    ],
  },
  {
    name: "A: Weapon ability: HIT:6+=+2HITS",
    computed_keywords: [],
    computed_leaders: [],
    computed_roles: ["Attacker: Ranged"],
    computed_toughness: null,
    order_slain_auto: true,
    order_slain_model_types: [
      {
        modelTypeId: "7e028ac7-7f1e-45fa-b278-c71783830904",
        modelTypeName: null,
        unitId: "8e4425de-d832-4dab-b230-3c912ab7c006",
      },
    ],
    units: [
      {
        id: "8e4425de-d832-4dab-b230-3c912ab7c006",
        leader: false,
        name: "A: Weapon ability: HIT:6+=+2HITS > Unit 1",
        abilities: [],
        points: null,
        model_types: [
          {
            weapons: [
              {
                name: "Baseline",
                type: "Ranged",
                attacks: 3,
                strength: 5,
                ap: 0,
                damage: 1,
                countPerUnit: 5,
                id: "6e318134-f6a9-41dc-bc7e-05519162adcf",
                bs: 3,
                ws: null,
                nameUnique: "Baseline",
                abilities: [],
              },
              {
                name: "Baseline with weapon ability",
                type: "Ranged",
                attacks: 3,
                strength: 5,
                ap: 0,
                damage: 1,
                abilities: [
                  {
                    description: "Hit roll of 6+ : 2 extra hits",
                    id: "23cf2f54-b7e2-4319-a50a-219e834ea6af",
                    conditions: [
                      {
                        data: {
                          attackStep: {
                            title: "Hit roll",
                            key: "hitRoll",
                          },
                          rollReq: {
                            title: "Specific roll",
                            key: "specificRoll",
                          },
                          rollState: {
                            title: "Modified",
                            key: "modified",
                          },
                          rollTarget: {
                            title: "Or greater",
                            key: "orGreater",
                          },
                          rollValue: "6",
                        },
                        preselected: false,
                        text: "Attack step roll",
                        type: "attackStepRoll",
                        required: true,
                      },
                    ],
                    effect: {
                      data: {
                        option: {
                          title: "Extra hits",
                          key: "extraHits",
                        },
                        extrasValue: "2",
                      },
                      text: "Generate extras",
                      type: "generateExtras",
                    },
                    scope: ["weapon"],
                    aliases: [],
                    aliasActive: true,
                    sharedWithAllUnits: false,
                  },
                ],
                countPerUnit: 5,
                id: "93962eec-67f1-4055-9afe-7019726861b7",
                bs: 3,
                ws: null,
                nameUnique: "Baseline with weapon ability",
              },
            ],
            id: "7e028ac7-7f1e-45fa-b278-c71783830904",
            name: "A: Weapon ability: HIT:6+=+2HITS > Unit 1 > Model type 1",
            ignore: null,
            invuln: null,
          },
        ],
        abilities_selected: [],
      },
    ],
    weapons_selected_melee: [],
    weapons_selected_ranged: [
      "6e318134-f6a9-41dc-bc7e-05519162adcf",
      "93962eec-67f1-4055-9afe-7019726861b7",
    ],
  },
  {
    name: "A: Weapon ability: WOUND:6=DAMAGE:2",
    computed_keywords: [],
    computed_leaders: [],
    computed_roles: ["Attacker: Ranged"],
    computed_toughness: null,
    order_slain_auto: true,
    order_slain_model_types: [
      {
        modelTypeId: "f493c7c1-a201-4fa6-9a77-0fde6ecf0fdb",
        modelTypeName: null,
        unitId: "8188a1b6-ab8b-4ffc-b79f-81dacae0818c",
      },
    ],
    units: [
      {
        id: "8188a1b6-ab8b-4ffc-b79f-81dacae0818c",
        leader: false,
        name: "A: Weapon ability: WOUND:6=DAMAGE:2 > Unit 1",
        abilities: [],
        points: null,
        model_types: [
          {
            weapons: [
              {
                name: "Baseline",
                type: "Ranged",
                attacks: 3,
                strength: 3,
                ap: 0,
                damage: 1,
                countPerUnit: 20,
                id: "ee6bea78-fd79-49de-942c-df419a1ae64b",
                bs: 3,
                ws: null,
                nameUnique: "Baseline",
                abilities: [],
              },
              {
                name: "Baseline with WOUND:6=DAMAGE:2",
                type: "Ranged",
                attacks: 3,
                strength: 3,
                ap: 0,
                damage: 1,
                abilities: [
                  {
                    description:
                      "Wound roll of 6 (unmodified) : set damage to 2",
                    id: "e07acb31-50a6-47a4-b0ff-b58e6a291a3a",
                    conditions: [
                      {
                        data: {
                          attackStep: {
                            title: "Wound roll",
                            key: "woundRoll",
                          },
                          rollReq: {
                            title: "Specific roll",
                            key: "specificRoll",
                          },
                          rollState: {
                            title: "Unmodified",
                            key: "unmodified",
                          },
                          rollTarget: {
                            title: "Exact",
                            key: "exact",
                          },
                          rollValue: "6",
                        },
                        preselected: false,
                        text: "Attack step roll",
                        type: "attackStepRoll",
                        required: true,
                      },
                    ],
                    effect: {
                      data: {
                        application: {
                          title: "Damage",
                          key: "damage",
                        },
                        operator: {
                          title: "Replace",
                          key: "replace",
                        },
                        absoluteValue: "2",
                      },
                      text: "Modify (absolute)",
                      type: "modifyAbsolute",
                    },
                    scope: ["weapon"],
                    aliases: [],
                    aliasActive: true,
                    sharedWithAllUnits: false,
                  },
                ],
                countPerUnit: 20,
                id: "88b1d0a9-18d6-4c17-aa2d-5f8c4056fe85",
                bs: 3,
                ws: null,
                nameUnique: "Baseline with WOUND:6=DAMAGE:2",
              },
            ],
            id: "f493c7c1-a201-4fa6-9a77-0fde6ecf0fdb",
            name: "A: Weapon ability: WOUND:6=DAMAGE:2 > Unit 1 > Model type 1",
            ignore: null,
            invuln: null,
          },
        ],
        abilities_selected: [],
      },
    ],
    weapons_selected_melee: [],
    weapons_selected_ranged: [
      "ee6bea78-fd79-49de-942c-df419a1ae64b",
      "88b1d0a9-18d6-4c17-aa2d-5f8c4056fe85",
    ],
  },
]
